import React, { useCallback, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Stamp } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from './ui/card';
import { Button } from './ui/button';
import NewSerialRunDialog from './faceplates/NewSerialRunDialog';
import { RunBadge } from '../pages/FaceplatesPage';

// Work order card: serial runs per line + manual "Serialize" for lines not yet serialized.
export const WoSerialRunsCard = ({ api, wo }) => {
  const [runs, setRuns] = useState([]);
  const [tpls, setTpls] = useState([]);
  const [preset, setPreset] = useState(null);
  const load = useCallback(() => api().get('/serial-runs', { params: { source_id: wo.id } }).then(r => setRuns(r.data)).catch(() => {}), [api, wo.id]);
  useEffect(() => { load(); api().get('/faceplates').then(r => setTpls(r.data.templates)).catch(() => {}); }, [load]); // eslint-disable-line react-hooks/exhaustive-deps
  const lines = (wo.lines || []).filter(l => l.product_sku);
  return (
    <Card className="industrial-card" data-testid="wo-serial-runs-card">
      <CardHeader className="border-b border-slate-100 pb-3"><CardTitle className="text-base flex items-center gap-2"><Stamp className="w-4 h-4" /> Serials &amp; Faceplates</CardTitle></CardHeader>
      <CardContent className="p-4 space-y-2">
        <p className="text-xs text-slate-500">Lines are serialized automatically when this WO moves to Complete (if the product has a serial pattern or a faceplate).</p>
        {lines.length === 0 && <p className="text-sm text-slate-400">No product lines to serialize.</p>}
        {lines.map((l, i) => {
          const r = runs.find(x => x.line_id === l.id && x.status !== 'Void');
          return (
            <div key={l.id} className="flex items-center justify-between gap-3 border border-slate-200 rounded-sm px-3 py-2 text-sm" data-testid={`wo-serial-line-${i}`}>
              <span><span className="mono font-semibold">{l.product_sku}</span> × {l.quantity}</span>
              {r ? (
                <span className="flex items-center gap-2"><span className="mono text-xs">{r.units[0]?.serial}{r.units.length > 1 ? ` … ${r.units[r.units.length - 1].serial}` : ''}</span>
                  <RunBadge s={r.status} testId={`wo-serial-status-${i}`} /><Link to={`/faceplates/runs/${r.id}`} className="text-blue-700 hover:underline text-xs" data-testid={`wo-serial-open-${i}`}>Open</Link></span>
              ) : (
                <Button size="sm" variant="outline" className="h-7 rounded-sm" onClick={() => setPreset({ source_type: 'wo_v2', source_id: wo.id, line_id: l.id, label: `${l.product_sku} × ${l.quantity}` })} data-testid={`wo-serialize-btn-${i}`}>Serialize now</Button>
              )}
            </div>
          );
        })}
      </CardContent>
      <NewSerialRunDialog api={api} open={!!preset} onOpenChange={(o) => { if (!o) setPreset(null); }} templates={tpls} preset={preset} onCreated={() => load()} />
    </Card>
  );
};

export default WoSerialRunsCard;
